import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import '../choose-plan/plan.scss';
import './orderSummaryComponent.scss';
import CustomizedPlan from '../Customized-Plan/CustomizedPlan';
import { submitKamOrder, submitClarity } from '../../../common/helper/api.helper';
import CancelOrderPopup from '../cancelOrderPopup/cancelOrderPopup';
import { stopBackgroundScrolling, getFromSessionStorage, numberWithCommas, checkIfItemCodePresentInSiteSpecs } from '../../../common/utils/app.utils';
import { FETCH_SUCCESS, MODULE_ID, PNQ_AUTHORIZATION_HEADER, INITIATE_FETCHING, ATTRIBUTE_TEXT } from '../../../home/common/constants/constants';
import { contractPeriodOptions, PRODUCT_NAME, PRODUCT_TYPE } from '../../../common/constants/app.constants';
import RadioGroup from 'b2b-ui-components-lib/lib/components/radioGroup';
import Input from 'b2b-ui-components-lib/lib/components/input';
import { faOnDedicatedKamChoosePlanPageLoad, faOnDedicatedKamSaveOrderClick } from '../../services/analytics.service';
import KamPriceNegotation from '../kam-price-negotation/kamPriceNegotation';
import Select from 'b2b-ui-components-lib/lib/components/select';
import { HARDWARE_TYPE } from 'home/view/manage-feasibility/constants';

const OrderSummary = ({
  kamPlan,
  selectedPlan,
  selectedContractPeriod,
  setselectedcontractOption,
  doaStatus,
  doaId,
  pnqPayload,
  serviceType,
  paramsValue,
  getKamLeadData,
  setAPIFetechingState,
  selectedRouter,
  plansArray,
  selectedIpAttributes,
  ipAttributeType,
  selectedHardwareType,
  feasibilityData = {},
  selectedPrimaryMedia = {},
  itemCode
}) => {
  let standardPricePlan = true;
  let getArc = null;
  let getOrc = null;
  let lineItems = pnqPayload && pnqPayload.lineItems && pnqPayload.lineItems.length > 0 && pnqPayload.lineItems[0];
  let priceValue = lineItems && lineItems.plan && lineItems.plan.price;
  if (priceValue && priceValue.customPricePlan) {
    standardPricePlan = false;
    getArc = priceValue && priceValue.rental;
    getOrc = priceValue && priceValue.oneTimeCharge;
  } else if (kamPlan && kamPlan.price && !kamPlan.price.customPricePlan) {
    standardPricePlan = true;
  }
  let [showStandard, setshowStandard] = useState(standardPricePlan);
  let [floorPlan, setfloorPlan] = useState(false);
  let [active, setactive] = useState(false);
  let [showPopup, setshowPopup] = useState(false);
  let [disabled, setdisabled] = useState(false);
  let [arc, setarc] = useState(getArc ? getArc : selectedPlan && selectedPlan.price && selectedPlan.price.amount);
  let [otc, setotc] = useState(getOrc ? getOrc : selectedPlan && selectedPlan.price && selectedPlan.price.otc);
  const filedata = [{ name: '', file: '', success: false, error: false }];
  let [fileArray, setfileArray] = useState(filedata);
  let [clarityRemarks, setclarityRemarks] = useState('');
  let [remarks, setremarks] = useState('');
  let [remarksError, setRemarksError] = useState(false);
  const planOptions = [
    { id: 'standardPlan', displayName: 'Standard Plan' },
    { id: 'floorPlan', displayName: 'Floor Plan' }
  ];
  const [selectedPlanOption, setSelectedOption] = useState(floorPlan ? planOptions[1] : planOptions[0]);
  const onPlanChange = (value) => {
    setSelectedOption(value);
    setfloorPlan(value && value.id === 'floorPlan' ? true : false);
  };
  const history = useHistory();
  const saveOrder = () => {
    const analyticsParams = {
      planPeriod: selectedContractPeriod.value * 12,
      rental: showStandard ? (!floorPlan ? selectedPlan && selectedPlan.price.amount : selectedPlan && selectedPlan.floorPrice && selectedPlan.floorPrice.amount) : arc,
      otc: showStandard ? (!floorPlan ? selectedPlan && selectedPlan.price.otc : selectedPlan && selectedPlan.floorPrice.otc) : otc,
      planType: showStandard ? 'standard plan' : 'customized plan',
      planSubType: selectedPlanOption.displayName
    };
    faOnDedicatedKamSaveOrderClick(analyticsParams);
    if (!remarks && doaStatus == 'CLARITY_REQUIRED') {
      setRemarksError(true);
    } else {
      setAPIFetechingState({ type: INITIATE_FETCHING });
      let pnqToken = getFromSessionStorage(MODULE_ID, PNQ_AUTHORIZATION_HEADER);
      let getServiceType = serviceType ? serviceType : selectedPlan && selectedPlan.service;
      let pnqdata = { ...pnqPayload };
      pnqdata.contractPeriod =
        selectedContractPeriod && selectedContractPeriod.value
          ? selectedContractPeriod.value * 12
          : selectedContractPeriod
          ? selectedContractPeriod * 12
          : pnqdata && pnqdata.contractPeriod;
      let payLoad = { pnqPayload, contractPeriod: selectedContractPeriod && selectedContractPeriod.value };
      const filePayload = fileArray.filter((item) => item.name && item.file).map(({ success, error, ...rest }) => rest);
      // console.log('filePayload', filePayload);
      if (showStandard) {
        let planPrice;
        planPrice = pnqdata.lineItems && pnqdata.lineItems.length > 0 && pnqdata.lineItems[0].plan && pnqdata.lineItems[0].plan.price;
        planPrice.rental = !floorPlan ? selectedPlan && selectedPlan.price.amount : selectedPlan && selectedPlan.floorPrice && selectedPlan.floorPrice.amount;
        planPrice.otc = !floorPlan ? selectedPlan && selectedPlan.price.otc : selectedPlan && selectedPlan.floorPrice.otc;
        planPrice.oneTimeCharge = !floorPlan ? selectedPlan && selectedPlan.price.otc : selectedPlan && selectedPlan.floorPrice.otc;
        planPrice.customPricePlan = showStandard ? false : true;
        if (pnqdata.lineItems && pnqdata.lineItems.length > 0 && pnqdata.lineItems[0].plan && plansArray && plansArray.length > 0) {
          pnqdata.lineItems[0].subProductName = getServiceType;
          let lineItemSpecs = pnqdata.lineItems[0].plan.specs;
          let siteSpecs = pnqdata.lineItems[0].plan.site[0] && pnqdata.lineItems[0].plan.site[0].siteSpecs;
          let speed = pnqdata.lineItems[0].plan.bandwidth;
          let routerIndex = plansArray.findIndex((plansData) => plansData.speed === speed);
          if (routerIndex < 0) {
            routerIndex = 0;
          }
          let setRouterIndex = plansArray[routerIndex].id;
          let getLineItemSpecs = checkLineItemSpecs(lineItemSpecs, getServiceType, setRouterIndex);
          let getSiteSpecs = checkSiteSpecs(siteSpecs, getServiceType, setRouterIndex);
          pnqdata.lineItems[0].plan.specs = getLineItemSpecs;
          pnqdata.lineItems[0].plan.site[0].siteSpecs = getSiteSpecs;
          pnqdata.lineItems[0].plan.site[0].specs = getSiteSpecs;
          pnqdata.lineItems[0].plan.price = planPrice;
        }
        payLoad = { ...pnqdata };
      } else {
        let remarkPayload = [{ userType: 'KAM', remarks: remarks }];
        payLoad = {
          ...pnqPayload,
          remarks: remarkPayload,
          attachments: filePayload,
          contractPeriod: selectedContractPeriod.value
        };
      }
      if (doaStatus == 'CLARITY_REQUIRED') {
        let updatedPlans = [];
        updatedPlans =
          pnqPayload &&
          pnqPayload.lineItems.length &&
          pnqPayload.lineItems.map((item) => ({
            lineItemId: item.lineItemId,
            price: { rental: arc, oneTimeCharge: otc, customPricePlan: true }
          }));
        var claritypayLoad = {
          remarks: remarks,
          updatedPlans: updatedPlans,
          contractPeriod:
            selectedContractPeriod && selectedContractPeriod.value
              ? selectedContractPeriod.value * 12
              : selectedContractPeriod
              ? selectedContractPeriod * 12
              : pnqdata && pnqdata.contractPeriod,
          attachments: filePayload
        };
      }
      if (pnqdata && pnqdata.leadStatus === 'REQUIRED_PRICE_NEGOTIATION' && !showStandard) {
        let planPrice;
        planPrice = pnqdata.lineItems && pnqdata.lineItems.length > 0 && pnqdata.lineItems[0].plan && pnqdata.lineItems[0].plan.price;
        planPrice.rental = arc;
        planPrice.oneTimeCharge = otc;
        planPrice.customPricePlan = showStandard ? false : true;
        if (pnqdata.lineItems && pnqdata.lineItems.length > 0 && pnqdata.lineItems[0].plan && plansArray && plansArray.length > 0) {
          pnqdata.lineItems[0].subProductName = getServiceType;
          let lineItemSpecs = pnqdata.lineItems[0].plan.specs;
          let siteSpecs = pnqdata.lineItems[0].plan.site[0] && pnqdata.lineItems[0].plan.site[0].siteSpecs;
          let speed = pnqdata.lineItems[0].plan.bandwidth;
          let routerIndex = plansArray && plansArray.length > 0 && plansArray.findIndex((plansData) => plansData.speed === speed);
          if (routerIndex < 0) {
            routerIndex = 0;
          }
          let setRouterIndex = plansArray[routerIndex].id;
          let getLineItemSpecs = checkLineItemSpecs(lineItemSpecs, getServiceType, setRouterIndex);
          let getSiteSpecs = checkSiteSpecs(siteSpecs, getServiceType, setRouterIndex);
          pnqdata.lineItems[0].plan.specs = getLineItemSpecs;
          pnqdata.lineItems[0].plan.site[0].specs = getSiteSpecs;
          pnqdata.lineItems[0].plan.site[0].siteSpecs = getSiteSpecs;
          pnqdata.lineItems[0].plan.price = planPrice;
        }
        payLoad = { ...pnqdata };
      }

      // set itemCode in payload
      if (pnqdata?.lineItems[0]?.plan?.site[0]?.siteSpecs && itemCode) {
        if (checkIfItemCodePresentInSiteSpecs(pnqdata?.lineItems[0]?.plan?.site[0]?.siteSpecs)) {
          pnqdata.lineItems[0].plan.site[0].siteSpecs.map((item) => {
            if (item['name'] === 'itemCode') {
              item['value'] = itemCode;
            }
          });
        } else {
          pnqdata.lineItems[0].plan.site[0].siteSpecs = [
            ...pnqdata.lineItems[0].plan.site[0].siteSpecs,
            {
              name: 'itemCode',
              value: itemCode
            }
          ];
        }

        payLoad = { ...pnqdata };
      }

      let promise = doaStatus == 'CLARITY_REQUIRED' ? submitClarity(claritypayLoad, pnqToken) : submitKamOrder(payLoad, pnqToken);
      promise
        .then((res) => {
          let leadStatusData = res && res.data && res.data.result && res.data.result.leadStatus;
          setAPIFetechingState({ type: FETCH_SUCCESS });
          setRemarksError(false);
          getKamLeadData('', paramsValue);
        })
        .catch((err) => {
          setAPIFetechingState({ type: FETCH_SUCCESS });
          if (doaStatus == 'CLARITY_REQUIRED') {
            setRemarksError(true);
          }
        });
    }
  };
  const checkLineItemSpecs = (lineItemSpecs, getServiceType, routerIndex) => {
    let lineItemIndex = lineItemSpecs && lineItemSpecs.length > 0 && lineItemSpecs.findIndex((lineItemSpec) => lineItemSpec.name === 'cpe');
    if (getServiceType === 'UNMANAGED') {
      if (lineItemIndex !== -1) {
        lineItemSpecs[lineItemIndex].value = 'None';
        lineItemSpecs[lineItemIndex].commercial = false;
      } else {
        let cpeList = {};
        cpeList.name = 'cpe';
        cpeList.description = 'cpe';
        cpeList.value = 'None';
        cpeList.commercial = false;
        lineItemSpecs.push(cpeList);
      }
    } else {
      if (lineItemIndex !== -1) {
        lineItemSpecs[lineItemIndex].value = selectedRouter && selectedRouter[routerIndex].make;
        lineItemSpecs[lineItemIndex].commercial =
          selectedRouter && selectedRouter[routerIndex] && selectedRouter && selectedRouter[routerIndex].commercial ? selectedRouter[routerIndex].commercial : false;
      } else {
        let cpeList = {};
        cpeList.name = 'cpe';
        cpeList.description = 'cpe';
        cpeList.value = selectedRouter && selectedRouter[routerIndex].make;
        cpeList.commercial =
          selectedRouter && selectedRouter[routerIndex] && selectedRouter && selectedRouter[routerIndex].commercial ? selectedRouter[routerIndex].commercial : false;
        lineItemSpecs.push(cpeList);
      }
    }

    if (Array.isArray(lineItemSpecs)) {
      lineItemSpecs?.push({
        name: 'hardwareType',
        value: HARDWARE_TYPE[selectedHardwareType?.value],
        linkType: 'PRIMARY',
        commercial: false
      });
    }

    return lineItemSpecs;
  };
  const checkSiteSpecs = (siteSpecs, getServiceType, routerIndex) => {
    let getSelectedIpAttributes =
      selectedIpAttributes && selectedIpAttributes.length > 0 && getFromSessionStorage(MODULE_ID, PRODUCT_NAME) === PRODUCT_TYPE.DEDICATED_INTERNET
        ? selectedIpAttributes
        : selectedPlan && selectedPlan.specs;
    const dualLmAttributesIndex =
      getSelectedIpAttributes && getSelectedIpAttributes.length > 0 && getSelectedIpAttributes.findIndex((getSelectedIpAttribute) => getSelectedIpAttribute.value === 'Dual LM');
    if (siteSpecs && siteSpecs.length > 0) {
      for (let siteIndex = 0; siteIndex < siteSpecs.length; siteIndex++) {
        if (dualLmAttributesIndex === -1 && siteSpecs[siteIndex].linkType === 'SECONDARY') {
          siteSpecs.splice(siteIndex, 1);
        } else if (dualLmAttributesIndex === -1 && siteSpecs[siteIndex].name === 'lastMile') {
          siteSpecs[siteIndex].description = 'Standard';
        } else if (
          dualLmAttributesIndex !== -1 &&
          siteSpecs[siteIndex].linkType === 'SECONDARY' &&
          (siteSpecs[siteIndex].name === 'lastMile' || siteSpecs[siteIndex].name === 'redundancy')
        ) {
          siteSpecs.splice(siteIndex, 1);
        }
      }
    }
    if (getSelectedIpAttributes && getSelectedIpAttributes.length > 0) {
      for (let i = 0; i < getSelectedIpAttributes.length; i++) {
        let ipAttributesIndex =
          siteSpecs &&
          siteSpecs.length > 0 &&
          siteSpecs.findIndex((siteSpec) => siteSpec.name === getSelectedIpAttributes[i].name && siteSpec.linkType === getSelectedIpAttributes[i].linkType);
        let getSelectedIpAttributesIndex = i;
        if (ipAttributesIndex !== -1 && (ipAttributesIndex || ipAttributesIndex === 0)) {
          getSelectedIpAttributesIndex =
            getSelectedIpAttributes &&
            getSelectedIpAttributes.length > 0 &&
            getSelectedIpAttributes.findIndex(
              (getSelectedIpAttribute) =>
                getSelectedIpAttribute.name === siteSpecs[ipAttributesIndex].name && getSelectedIpAttribute.linkType === siteSpecs[ipAttributesIndex].linkType
            );
        }
        if (getSelectedIpAttributesIndex !== -1) {
          getSelectedIpAttributesIndex = i;
        }
        if (getSelectedIpAttributesIndex > -1) {
          if (ipAttributesIndex > -1) {
            siteSpecs[ipAttributesIndex].value = getSelectedIpAttributes[getSelectedIpAttributesIndex].value;
            siteSpecs[ipAttributesIndex].commercial = getSelectedIpAttributes[getSelectedIpAttributesIndex].commercial;
            siteSpecs[ipAttributesIndex].linkType = getSelectedIpAttributes[getSelectedIpAttributesIndex].linkType;
          } else {
            let ipAttributesList = {};
            ipAttributesList.name = getSelectedIpAttributes[getSelectedIpAttributesIndex].name;
            ipAttributesList.description = getSelectedIpAttributes[getSelectedIpAttributesIndex].name;
            ipAttributesList.value = getSelectedIpAttributes[getSelectedIpAttributesIndex].value;
            ipAttributesList.commercial = getSelectedIpAttributes[getSelectedIpAttributesIndex].commercial;
            ipAttributesList.linkType = getSelectedIpAttributes[getSelectedIpAttributesIndex].linkType;
            siteSpecs.push(ipAttributesList);
          }
        }
      }
    }
    // else if(selectedPlan && selectedPlan.specs && selectedPlan.specs.length > 0) {
    //   siteSpecs=selectedPlan.specs;
    // }
    let siteSpaceIndex = siteSpecs && siteSpecs.length > 0 && siteSpecs.findIndex((siteSpec) => siteSpec.name === 'cpeSpecification');
    if (getServiceType === 'UNMANAGED') {
      if (siteSpaceIndex > -1) {
        siteSpecs[siteSpaceIndex].value = null;
        siteSpecs[siteSpaceIndex].commercial = false;
      } else {
        let cpeSpecificationList = {};
        cpeSpecificationList.name = 'cpeSpecification';
        cpeSpecificationList.description = 'cpeSpecification';
        cpeSpecificationList.value = null;
        cpeSpecificationList.commercial = false;
        siteSpecs.push(cpeSpecificationList);
      }
    } else {
      if (siteSpaceIndex > -1) {
        siteSpecs[siteSpaceIndex].value = selectedRouter && selectedRouter[routerIndex].model;
        siteSpecs[siteSpaceIndex].commercial =
          selectedRouter && selectedRouter[routerIndex] && selectedRouter[routerIndex].commercial ? selectedRouter[routerIndex].commercial : false;
      } else {
        let cpeSpecificationList = {};
        cpeSpecificationList.name = 'cpeSpecification';
        cpeSpecificationList.description = 'cpeSpecification';
        cpeSpecificationList.value = selectedRouter && selectedRouter[routerIndex].model;
        cpeSpecificationList.commercial = selectedRouter && selectedRouter[routerIndex] && selectedRouter[routerIndex].commercial ? selectedRouter[routerIndex].commercial : false;
        siteSpecs.push(cpeSpecificationList);
      }
    }

    // set selected media(s) in submit order req object
    const isSiteManualFeasible = feasibilityData && feasibilityData.feasibilityStatus === 'MANUAL_INTERVENTION_REQUIRED';
    const isSitePendingThirdParty = feasibilityData && feasibilityData.feasibilityStatus === 'PENDING_FOR_THIRD_PARTY';

    if (!isSiteManualFeasible || !isSitePendingThirdParty) {
      if (selectedPrimaryMedia && selectedPrimaryMedia.key) {
        Array.isArray(siteSpecs) &&
          siteSpecs.length > 0 &&
          siteSpecs.map((item) => {
            if (item.name === 'media') {
              item.value = selectedPrimaryMedia.key;
            }

            return item;
          });
      }
    }

    return siteSpecs;
  };
  const cancelOrder = () => {
    stopBackgroundScrolling(true);
    setshowPopup(true);
  };

  const dropdownHandler = (val) => {
    setfloorPlan(val);
    setactive(false);
  };

  useEffect(() => {
    const params = {
      ...selectedPlan,
      planPeriod: selectedContractPeriod.value * 12,
      ipAttribute: ipAttributeType ? ATTRIBUTE_TEXT.NON_STANDARD : ATTRIBUTE_TEXT.STANDARD
    };
    faOnDedicatedKamChoosePlanPageLoad(params);
  }, []);

  return (
    <div className="orderSection">
      <div className="accordion-card">
        <div className="orderSummary">
          <h2 className="summary-head">Plan Pricing And Negotiation</h2>

          <div className="tabsection">
            <KamPriceNegotation selectedHardwareType={selectedHardwareType} ipAttributeType={ipAttributeType} pnqPayload={pnqPayload} selectedPlan={selectedPlan} />
            <ul className="tablist">
              <li onClick={() => setshowStandard(true)} className={showStandard ? 'active pl-0 standard-li' : 'pl-0 standard-li'}>
                Standard Plan
                <div className="underline"></div>
              </li>
              <li onClick={() => setshowStandard(false)} className={!showStandard ? 'active' : ''}>
                Customized Plan<div className="underline"></div>
              </li>
            </ul>
          </div>
          {showStandard && selectedPlan ? (
            <div className="negotiation_card">
              <div className="accordion-content">
                <div className="radio_items">
                  <RadioGroup options={planOptions} value={selectedPlanOption} onChange={onPlanChange} />
                </div>
                <div className="changes_field">
                  <div className="row">
                    <div className="flg-lg-2 flg-md-4">
                      <Input
                        label="Annual Recurring Charges"
                        value={`₹${
                          !floorPlan
                            ? selectedPlan && selectedPlan.price && numberWithCommas(selectedPlan.price.amount)
                            : selectedPlan && selectedPlan.floorPrice && numberWithCommas(selectedPlan.floorPrice.amount)
                        }`}
                        required
                        disabled
                      />
                    </div>
                    <div className="flg-lg-2 flg-md-4">
                      <Input
                        label="One-time Charges"
                        value={`₹${
                          !floorPlan
                            ? selectedPlan && selectedPlan.price && numberWithCommas(selectedPlan.price.otc)
                            : selectedPlan && selectedPlan.floorPrice && numberWithCommas(selectedPlan.floorPrice.otc)
                        }`}
                        required
                        disabled
                      />
                    </div>
                    <div className="flg-lg-2 flg-md-4">
                      {doaStatus === 'CLARITY_REQUIRED' ? (
                        <div className="row">
                          <div className="flg-lg-5 flg-sm-12">
                            <Select
                              placeholder="Choose a contract period"
                              value={selectedContractPeriod}
                              onChange={setselectedcontractOption}
                              options={contractPeriodOptions}
                              required
                              touched
                            />
                          </div>
                        </div>
                      ) : (
                        <Input
                          label="Contract Period"
                          value={
                            selectedContractPeriod && selectedContractPeriod.value
                              ? selectedContractPeriod.value === 1
                                ? selectedContractPeriod.value + ' Year'
                                : selectedContractPeriod.value + ' Years'
                              : selectedContractPeriod
                              ? selectedContractPeriod + ' Year'
                              : '1 Year'
                          }
                          required
                          disabled
                        />
                      )}
                    </div>
                  </div>
                </div>
                <div className="charges_details">
                  <h6>
                    Total charges (without tax):{' '}
                    <strong>
                      &#8377;{' '}
                      {!floorPlan
                        ? selectedPlan && selectedPlan.price && numberWithCommas(selectedPlan.price.amount * selectedContractPeriod.value + selectedPlan.price.otc)
                        : selectedPlan && selectedPlan.floorPrice && numberWithCommas(selectedPlan.floorPrice.amount * selectedContractPeriod.value + selectedPlan.floorPrice.otc)}
                    </strong>
                  </h6>
                  <p>GST rates as applicable</p>
                </div>
              </div>
              <div className="accordion-footer">
                <div className="info_strip danger_text">
                  <div className="info_text">Status: Customer has requested for customized pricing.</div>
                </div>
              </div>
            </div>
          ) : (
            selectedPlan && (
              <CustomizedPlan
                selectedContractPeriod={selectedContractPeriod}
                remarksError={remarksError}
                setRemarksError={setRemarksError}
                pnqPayload={pnqPayload}
                selectedPlan={selectedPlan}
                arc={arc}
                setarc={setarc}
                otc={otc}
                setotc={setotc}
                doaStatus={doaStatus}
                doaId={doaId}
                fileArray={fileArray}
                setfileArray={setfileArray}
                remarks={remarks}
                setremarks={setremarks}
                clarityRemarks={clarityRemarks}
                setclarityRemarks={setclarityRemarks}
                setContractPeriod={setselectedcontractOption}
              />
            )
          )}
          {pnqPayload && (pnqPayload.leadStatus === 'REQUIRED_PRICE_NEGOTIATION' || doaStatus == 'CLARITY_REQUIRED') ? (
            <div className="buttonsection">
              <button type="button" className="btn activebtn" onClick={saveOrder}>
                {showStandard ? 'Save Order' : 'Submit Pricing'}
              </button>
              <button type="button" className={`btn activebtn btn-transparent ${disabled ? 'disabled' : ''}`} onClick={cancelOrder}>
                Cancel Order
              </button>
            </div>
          ) : (
            <div className="buttonsection">
              <button type="button" className="btn activebtn disabled">
                {showStandard ? 'Save Order' : 'Submit Pricing'}
              </button>
              <button type="button" className={`btn activebtn disabled btn-transparent`}>
                Cancel Order
              </button>
            </div>
          )}
        </div>
      </div>

      {showPopup && <CancelOrderPopup showPopup={showPopup} setshowPopup={setshowPopup} setdisabled={setdisabled} />}
    </div>
  );
};

export default OrderSummary;
